/**
 * Open Graph / Twitter preview images per logical page key (matches App.js pageKey).
 * Paths are under site origin (same host as SITE_ORIGIN_CANONICAL).
 */
export const socialPreviewByPageKey = {
  home: {
    imagePath: "/resources/selena-fatada-front.png",
    alt: "Exterior AUTO STOP SelenaService — boxe mecanică și recepție interactivă, Strada General Magheru nr. 73, Slobozia, Ialomița",
  },
  pilkington: {
    imagePath: "/resources/pilkington-work-hero.png",
    alt: "Lucrări parbrize și montaj Pilkington — Selena Service Slobozia",
  },
  climate: {
    imagePath: "/resources/selena-mecanica.jpg",
    alt: "Service auto și climatizare — Selena Service Slobozia",
  },
  mechanics: {
    imagePath: "/resources/mechanics-hero.png",
    alt: "Mecanică auto și revizii multimarcă — Selena Service",
  },
  vinParts: {
    imagePath: "/resources/mechanics-hero.png",
    alt: "Orientare piese auto după VIN — Selena Service",
  },
  diagnostics: {
    imagePath: "/resources/selena-mecanica.jpg",
    alt: "Diagnoză computerizată auto — Selena Service Slobozia",
  },
  oils: {
    imagePath: "/resources/oils-hero.png",
    alt: "Consultanță ulei motor și schimb ulei — Selena Service",
  },
  paint: {
    imagePath: "/resources/paint-hero.png",
    alt: "Vopsitorie auto în cabină — Selena Service Slobozia",
  },
  itp: {
    imagePath: "/resources/itp-hero.png",
    alt: "Stație ITP auto și camioane — Selena Service Slobozia",
  },
  tachograph: {
    imagePath: "/resources/selena-itp-camioane.jpg",
    alt: "Verificare tahograf și servicii vehicule comerciale — Selena Service",
  },
  claims: {
    imagePath: "/resources/paint-hero.png",
    alt: "Tinichigerie și vopsitorie în service — continuare după constatarea daunei, Selena Service Slobozia",
  },
  terms: {
    imagePath: "/resources/selena-fatada-front.png",
    alt: "AUTO STOP SelenaService — Strada General Magheru nr. 73, Slobozia",
  },
  notFound: {
    imagePath: "/resources/selena-fatada-front.png",
    alt: "AUTO STOP SelenaService — Slobozia",
  },
};
